import ChatFile from "./ChatFIle";

export default ChatFile;
